import { Box } from '@mui/material'
import { useMemo } from 'react'
import { StockBuildTableData, StockBuildTableProps } from './StockBuild.types'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'

export const StockBuildMUITable = ({
  data,
  isLoading,
  handleRowClick,
  skuCodes,
  skuNames,
  siteCodes,
}: StockBuildTableProps) => {
  const handleRowClickWrapper = (params: any) => {
    const selectedRow = data.find(
      (row: StockBuildTableData) => row.id === params.id
    )
    if (selectedRow) {
      handleRowClick([selectedRow])
    }
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Site',
        field: 'siteKey',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU Code',
        field: 'skuCode',
        width: 200,
        type: 'string',
      },
      {
        headerName: 'Product description',
        field: 'productDescription',
        width: 300,
        type: 'string',
      },
      {
        headerName: 'Avg. stock projection constrained',
        field: 'averageStockProjectionConstrained',
        type: 'number',
        flex: 1,
      },
      {
        headerName: 'Avg. stock projection excess',
        field: 'averageStockProjectionExcess',
        type: 'number',
        flex: 1,
      },
      {
        headerName: 'Stock projection excess',
        field: 'stockProjectionExcess',
        type: 'number',
        flex: 1,
      },
      {
        headerName: 'Stock projection increase',
        field: 'stockProjectionIncrease',
        type: 'number',
        flex: 1,
      },
      {
        headerName: 'Avg. safety stock',
        field: 'averageSafetyStock',
        type: 'number',
        flex: 1,
      },
    ],
    [skuCodes, skuNames, siteCodes]
  )
  // No-op functions for BaseTable required props (read-only table)
  const updateTableData = () => {
    // This is a read-only table, no updates needed
  }

  const uploadData = () => {
    // No upload functionality needed
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={uploadData}
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={true}
        handleRowClick={handleRowClickWrapper}
        downloadFileName="StockBuildData"
        getRowId={(row) => row.id}
      />
    </Box>
  )
}
